import { STATUS_LABELS, STATUS_TONE, PAYOUT_STATUS } from "@/lib/format";

const TONE_CLS = {
  success: "bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 border-emerald-500/20",
  warning: "bg-amber-500/10 text-amber-600 dark:text-amber-400 border-amber-500/20",
  info: "bg-primary/10 text-primary border-primary/20",
  danger: "bg-red-500/10 text-red-600 dark:text-red-400 border-red-500/20",
  muted: "bg-muted text-muted-foreground border-border",
};

export default function StatusBadge({ status, kind = "payment", className = "" }) {
  let label, tone;
  if (kind === "payout") {
    label = PAYOUT_STATUS[status] || status;
    tone = { pending: "warning", processing: "info", completed: "success", failed: "danger" }[status] || "muted";
  } else {
    label = STATUS_LABELS[status] || status;
    tone = STATUS_TONE[status] || "muted";
  }
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium ${TONE_CLS[tone]} ${className}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {label}
    </span>
  );
}
